<div cdk-overlay-origin>
  <div class="td-wb-side-sheet-selector-toggle"
       [class.td-wb-side-sheet-selector-toggle--active]="isOpen()"
       [class.td-wb-side-sheet-selector-toggle--panel-top]="panelPosition() === 'top'">
    <div class="td-wb-side-sheet-selector-toggle__data"
         [class.td-wb-side-sheet-selector-toggle__data--hidden]="isToggleHidden()">
        @if (staticToggle() !== undefined) {
          <ng-content select="td-wb-side-sheet-selector-toggle-static" />
        } @else {
          @if (isEmpty()) {
            <span class="td-wb-side-sheet-selector-toggle__placeholder"
                  [attr.aria-hidden]="ariaLabel() === undefined"
                  [innerText]="placeholder() || '\u00A0'"></span>
          } @else {
            @if (customToggle() === undefined) {
              <span [innerText]="getSelectedItem()?.getLabel()">
              </span>
            }
            @if (customToggle() !== undefined) {
              <ng-content select="td-wb-side-sheet-selector-toggle" />
            }
          }
        }

        <!-- @if (customToggle === undefined) {
          @if(isEmpty()) {
            <span class="td-wb-side-sheet-selector-toggle__placeholder"
                  [attr.aria-hidden]="ariaLabel === undefined"
                  [innerText]="placeholder || '\u00A0'"></span>
          } @else {
            <span [innerText]="getSelectedItem()?.getLabel()">
            </span>
          }
        } @else {
          <ng-content select="td-wb-side-sheet-selector-toggle"></ng-content>
        } -->
    </div>
    <div class="td-wb-side-sheet-selector-toggle__caret">
      <div class="td-wb-side-sheet-selector-toggle__arrow"
           [class.td-wb-side-sheet-selector-toggle__arrow--up]="isOpen()">
      </div>
    </div>
  </div>
</div>

<td-wb-bottom-modal [showHeader]="false"
                    tdWbSwipe
                    (down)="close()"
                    [modalOpened]="isOpen()"
                    (onToggle)="onToggle($event)"
                    [focusTrap]="false"
                    #panel
                    [id]="'td-wb-side-sheet-selector__panel-' + labelId()"
                    role="listbox"
                    [attr.aria-labelledby]="ariaLabelledBy()"
                    tabindex="-1"
                    [class]="'td-wb-side-sheet-selector__panel--' + panelPosition()"
                    [style.maxHeight.px]="panelMaxHeight()"
                    (backdropClicked)="close()"
                    (keydown)="onKeyDown($event)">
    <ng-content />
    @if (platformIOS()) {
      <button class="td-wb-vh"
              (click)="close()"
              translate="tdWb.sideSheetSelector.CLOSE_ARIA">
        <td-wb-icon iconId="cross" />
      </button>
    }
  </td-wb-bottom-modal>


